var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.2871,
    width: 61,
    height: 58,
    rx: 20,
    transform: "rotate(51.3344 45.2871 0)",
    fill: "#CCE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.209,
    y: 5.93311,
    width: 57.5982,
    height: 54.7655,
    rx: 20,
    transform: "rotate(22.5589 26.209 5.93311)",
    fill: "#019EF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1992,
    y: 18.9331,
    width: 49,
    height: 47,
    rx: 15,
    fill: "#027BC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 27H49C51.7614 27 54 29.2386 54 32V55H31V27Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2002,
    y: 31.9331,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#027BC7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2002,
    y: 38.9331,
    width: 13,
    height: 4,
    rx: 2,
    fill: "#027BC7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2002,
    y: 45.9331,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#027BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAccount);
export default __webpack_public_path__ + "static/media/chartAccount.d3f59aed64c1589df081fedc59eff007.svg";
export { ForwardRef as ReactComponent };